<!-- Header -->
<div class="bg-gray-50 mb-6 px-3">
  <div class="grid grid-cols-12 gap-6">
    <div class="col-span-12">
      <div class="w-fit rounded-2xl border border-gray-300 bg-gradient-to-r from-gray-50 to-white px-5 py-3">
        <div class="border-l-4 border-gray-800 pl-4">
          <p class="text-xs font-semibold uppercase tracking-[0.18em] text-gray-500">
            Reports Section
          </p>
          <h2 class="mt-1 text-2xl font-bold leading-tight tracking-tight text-gray-900">
            Metrics
          </h2>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Main Layout -->
<div class="grid min-h-screen grid-cols-12 gap-6 bg-gray-50 mb-6 px-3">

  <!-- Main Content -->
  <div class="col-span-12 lg:col-span-9">
    <div class="grid grid-cols-12 gap-5">

      <!-- Filters Card -->
      <ng-container>
        <div class="col-span-12 rounded-2xl border border-gray-300 bg-white p-5">

          <!-- Card Header -->
          <div class="mb-5 flex min-h-[64px] flex-col gap-4 border-b border-gray-300 pb-4 sm:flex-row sm:items-center sm:justify-between">
            <div class="flex min-h-[48px] flex-col justify-center">
              <p class="text-xs font-semibold uppercase tracking-wide text-gray-500">
                Filters
              </p>
              <h3 class="mt-1 text-lg font-bold text-gray-800">
                Report options
              </h3>
            </div>

            <!-- View Tabs -->
            <div class="inline-flex min-h-[44px] overflow-hidden rounded-xl border border-gray-300 bg-gray-100 p-1">
              <button
                type="button"
                class="cursor-pointer rounded-lg px-5 py-2.5 text-sm font-semibold transition"
                [ngClass]="viewMode() === 'query'
                  ? 'bg-gray-800 text-white'
                  : 'text-gray-700 hover:bg-white hover:text-gray-900'"
                (click)="goQuery.emit()">
                Report Builder
              </button>

              <button
                type="button"
                class="cursor-pointer rounded-lg px-5 py-2.5 text-sm font-semibold transition"
                [ngClass]="viewMode() === 'metrics'
                  ? 'bg-gray-800 text-white'
                  : 'text-gray-700 hover:bg-white hover:text-gray-900'"
                (click)="goMetrics.emit()">
                Page Metrics
              </button>
            </div>
          </div>

          <!-- Filter Fields -->
          <div class="grid grid-cols-12 gap-4">

            <!-- Website -->
            <div class="col-span-12 sm:col-span-6 xl:col-span-4">
              <label class="mb-2 block text-sm font-semibold text-gray-700">
                Website
              </label>
              <select
                class="w-full cursor-pointer rounded-xl border border-gray-300 bg-gray-50 px-4 py-2.5 text-sm text-gray-800 transition focus:border-gray-400 focus:outline-none focus:ring-2 focus:ring-gray-200"
                [ngModel]="selectedSiteId()"
                (ngModelChange)="onSiteChange($event)">
                <option [ngValue]="null" disabled>Select a site</option>
                <option *ngFor="let site of sites()" [ngValue]="site.ID">
                  {{ site.Domain }}
                </option>
              </select>
            </div>

            <!-- Platform -->
            <div class="col-span-12 sm:col-span-6 xl:col-span-4">
              <label class="mb-2 block text-sm font-semibold text-gray-700">
                Platform
              </label>
              <select
                class="w-full cursor-pointer rounded-xl border border-gray-300 bg-gray-50 px-4 py-2.5 text-sm text-gray-800 transition focus:border-gray-400 focus:outline-none focus:ring-2 focus:ring-gray-200"
                [ngModel]="selectedPlatformId()"
                (ngModelChange)="onPlatformChange($event)">
                <option *ngFor="let p of filteredPlatforms()" [ngValue]="p.id">
                  {{ p.platform }}
                </option>
              </select>
            </div>

            <!-- Period -->
            <div class="col-span-12 sm:col-span-6 xl:col-span-4">
              <label class="mb-2 block text-sm font-semibold text-gray-700">
                Date range
              </label>
              <select
                class="w-full cursor-pointer rounded-xl border border-gray-300 bg-gray-50 px-4 py-2.5 text-sm text-gray-800 transition focus:border-gray-400 focus:outline-none focus:ring-2 focus:ring-gray-200"
                [ngModel]="selectedPeriod()"
                (ngModelChange)="onPeriodChange($event)">
                <option [ngValue]="'days_28'">Last 30d</option>
                <option [ngValue]="'week'">Last 7d</option>
                <!-- <option [ngValue]="'custom'">Custom</option> -->
              </select>
            </div>

          </div>
        </div>
      </ng-container>

      <!-- Charts Stack -->
      <div class="col-span-12 flex flex-col gap-5">

        <!-- Empty State -->
        <div
          *ngIf="activeCharts().length === 0"
          class="rounded-2xl border border-gray-300 bg-white px-6 py-12 text-center">
          <div class="mx-auto max-w-md">
            <div class="mx-auto mb-4 flex h-12 w-12 items-center justify-center rounded-full border border-gray-300 bg-gray-100">
              <span class="text-2xl text-gray-400">▦</span>
            </div>

            <h4 class="text-base font-bold text-gray-800">
              No Metric Tools selected
            </h4>

            <p class="mt-2 text-sm leading-6 text-gray-500">
              Please select at least one of the Metric Tools to display charts.
            </p>
          </div>
        </div>

        <!-- Charts -->
        <ng-container *ngIf="activeCharts().length > 0">

          <!-- Followers -->
          <div
            *ngIf="activeCharts().includes('followers')"
            class="relative min-h-[350px] overflow-hidden rounded-2xl border border-gray-300 bg-white p-4">
            <app-followers-chart
              title="Followers"
              [selectedSiteId]="selectedSiteId()"
              [selectedPlatformId]="selectedPlatformId()"
              [selectedPeriod]="selectedPeriod()"
              [pages]="pages()"
              (dataReady)="onChartData($event)">
            </app-followers-chart>
          </div>

          <!-- Reach -->
          <div
            *ngIf="activeCharts().includes('reach')"
            class="relative min-h-[350px] overflow-hidden rounded-2xl border border-gray-300 bg-white p-4">
            <app-social-ai-reach-chart
              [selectedSiteId]="selectedSiteId()"
              [selectedPlatformId]="selectedPlatformId()"
              [selectedPeriod]="selectedPeriod()"
              [pages]="pages()">
            </app-social-ai-reach-chart>
          </div>

          <!-- Engagement -->
          <div
            *ngIf="activeCharts().includes('engagement')"
            class="relative min-h-[350px] overflow-hidden rounded-2xl border border-gray-300 bg-white p-4">
            <app-social-ai-engagement-chart
              [selectedSiteId]="selectedSiteId()"
              [selectedPlatformId]="selectedPlatformId()"
              [selectedPeriod]="selectedPeriod()"
              [pages]="pages()">
            </app-social-ai-engagement-chart>
          </div>

          <!-- Impressions -->
          <div
            *ngIf="activeCharts().includes('impressions')"
            class="relative min-h-[350px] overflow-hidden rounded-2xl border border-gray-300 bg-white p-4">
            <app-social-ai-impressions-chart
              [selectedSiteId]="selectedSiteId()"
              [selectedPlatformId]="selectedPlatformId()"
              [selectedPeriod]="selectedPeriod()"
              [pages]="pages()">
            </app-social-ai-impressions-chart>
          </div>

          <!-- Format -->
          <div
            *ngIf="activeCharts().includes('format')"
            class="relative min-h-[350px] overflow-hidden rounded-2xl border border-gray-300 bg-white p-4">
            <app-social-ai-format-breakdown-chart
              title="Format Breakdown"
              [selectedSiteId]="selectedSiteId()"
              [selectedPlatformId]="selectedPlatformId()"
              [selectedPeriod]="selectedPeriod()"
              [pages]="pages()">
            </app-social-ai-format-breakdown-chart>
          </div>

          <!-- Heatmap -->
          <div
            *ngIf="activeCharts().includes('heatmap')"
            class="relative min-h-[350px] overflow-hidden rounded-2xl border border-gray-300 bg-white p-4">
            <app-social-ai-heatmap-chart
              title="Heatmap"
              [selectedSiteId]="selectedSiteId()"
              [selectedPlatformId]="selectedPlatformId()"
              [selectedPeriod]="selectedPeriod()"
              [pages]="pages()">
            </app-social-ai-heatmap-chart>
          </div>

        </ng-container>
      </div>

    </div>
  </div>

  <!-- Sidebar Tools -->
  <div class="col-span-12 lg:col-span-3">
    <div class="sticky top-[150px] rounded-2xl border border-gray-300 bg-white p-5">

      <!-- Card Header -->
      <div class="mb-5 flex min-h-[64px] flex-col justify-center border-b border-gray-300 pb-4">
        <p class="text-xs font-semibold uppercase tracking-wide text-gray-500">
          Tools
        </p>
        <h3 class="mt-1 text-lg font-bold text-gray-800">
          Metric Tools
        </h3>
      </div>

      <!-- Chart Toggles -->
      <div>
        <p class="mb-3 text-xs font-semibold uppercase tracking-wide text-gray-500">
          Chart visibility
        </p>

        <div class="flex flex-col gap-2">
          <ng-container *ngFor="let c of chartOptions">
            <label
              class="flex min-h-[34px] cursor-pointer items-center gap-3 rounded-lg border border-transparent px-2 py-1.5 text-sm transition hover:border-gray-300 hover:bg-gray-50"
              *ngIf="!(isInstagramPlatform && (c.key === 'engagement' || c.key === 'impressions'))">
              <input
                #cb
                type="checkbox"
                [checked]="activeCharts().includes(c.key)"
                (change)="toggleChart(c.key, cb.checked)" />

              <span class="font-medium text-gray-700">
                {{ c.label }}
              </span>
            </label>
          </ng-container>
        </div>
      </div>

      <!-- Actions -->
      <div class="mt-6">
        <button
          class="mb-3 w-full min-h-[38px] cursor-pointer rounded-xl border border-gray-800 bg-gray-800 px-3 py-2.5 text-xs font-semibold text-white transition hover:bg-gray-900"
          type="button"
          (click)="bulkExportPdf()">
          Export PDF
        </button>

        <button
          class="w-full min-h-[38px] cursor-pointer rounded-xl border border-gray-300 bg-white px-3 py-2.5 text-xs font-semibold text-gray-700 transition hover:bg-gray-50"
          type="button"
          (click)="openSavedView()">
          Save View
        </button>
      </div>

    </div>
  </div>

</div>